export default __webpack_public_path__ + "static/media/venmo.ceb43de7.JPEG";